setVideoPlayerHeartsVisible